import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { Dome } from 'src/app/_models/dome';
import { UtilsService } from 'src/app/_services/utils.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {

  @Input() feature: any;
  @Input() observableDomes: Observable<Dome[]>;
  @Input() currentDomeId: string;
  @Output() featureChange = new EventEmitter<any>();

  public domes : Dome[];

  public selectedRows: Dome[];

  private selectedDomes : Dome[] = [];

  public constructor(private utils: UtilsService)
  {

  }

  ngOnInit() { 
    if(this.utils.isEmpty(this.feature.value))
    {
      this.feature.value = {};
      this.feature.value.destinations = [];
    }
    this.observableDomes.subscribe(response => {
      if(response)
      {
        if(this.currentDomeId)
        {
          this.domes = response.filter(x => x.id !== this.currentDomeId);
        }
        else
        {
          this.domes = response;
        }
        this.populateSelectedDomes();
      }
    });
  }

  private populateSelectedDomes()
  {
      this.feature.value.destinations.forEach(destination => {
        let dome = this.domes.find(dome=> dome.id == destination);
        if(!dome) return;
        this.selectedDomes.push(dome);
      });
      this.selectedRows = [...this.selectedDomes];
  }

  public onRowSelected()
  {
    this.feature.value.destinations = this.selectedRows.map(dome => dome.id);

    //distinct filter
    this.feature.value.destinations = this.feature.value.destinations.filter((v,i,a)=>a.indexOf(v)==i)
    this.featureChange.emit(this.feature);
  }

}